// extracted by mini-css-extract-plugin
module.exports = {"tabBtnContainer":"TabButton_tabBtnContainer__TBjY2","tabBtn":"TabButton_tabBtn__WTKNr","active":"TabButton_active__BfU4g"};